import { render, staticRenderFns } from "./MarketingStockProducts.vue?vue&type=template&id=85bce960&scoped=true"
import script from "./MarketingStockProducts.vue?vue&type=script&lang=js"
export * from "./MarketingStockProducts.vue?vue&type=script&lang=js"
import style0 from "./MarketingStockProducts.vue?vue&type=style&index=0&id=85bce960&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85bce960",
  null
  
)

export default component.exports